import { render, staticRenderFns } from "./myLeaveSick.vue?vue&type=template&id=75e0740d&scoped=true&"
import script from "./myLeaveSick.vue?vue&type=script&lang=js&"
export * from "./myLeaveSick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e0740d",
  null
  
)

export default component.exports